import React from 'react';
import './Desktop.scss';

export default function (props) {
	return <div className="Desktop">{props.children}</div>;
};
